export default {
    测试: 'test',
    加载中: 'Loading',
}
